import React from 'react'
import PropTypes from 'prop-types'
import { renderRoutes } from 'react-router-config'
import PCLNAnalytics from '@pcln/analytics'
import get from 'lodash/get'

class App extends React.Component {
  static propTypes = {
    route: PropTypes.object
  }
  componentDidMount () {
    const bootstrapLocale = get(this.props, 'route.routes[0].bootstrapData.locale', {})
    PCLNAnalytics.logEvent({
      action: bootstrapLocale.localeCodeSource || '',
      label: bootstrapLocale.localeCode || '',
      category: 'customerLocaleHP'
    })
  }

  render () {
    return (
      <div id='app-container' className='main' role='main'>
        {renderRoutes(this.props.route.routes)}
      </div>
    )
  }
}

export default App
